exports.list = {
    path: '/laporan_treatment',
    name: 'laporan_treatment_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_treatment/List.vue"),
}